import React from 'react'
import PropTypes from 'prop-types'
import SelectDropdown from '../../react-components/select-dropdown'

const EventListingFilters = ({ filters, onChange, loading, ...props }) => {
  if (!filters || !filters.length) return null;

  const propsSelectDropdown = filter => ({
    fieldLabel: filter.label,
    isLoading: loading,
    options: filter.list,
    value: filter.selected,
    onChange: args => onChange({ ...args, filter: filter.value })
  });

  const propsShowPerPageDropdown = {
    fieldLabel: props.labelItemsPerPage,
    isLoading: false,
    options: props.itemsPerPageOptions?.split?.(',')?.map?.(p => ({ label: p, value: p })),
    value: { label: props.itemsPerPage, value: props.itemsPerPage },
    className: 'pagination__items-per-page react-select',
    onChange: args => props.onItemsPerPageChange(args.value)
  };
  const itemsPerPage = (
    <SelectDropdown {...propsShowPerPageDropdown} />
  );

  return (
    <div className="event-listing-filters-items-per-page-wrapper">
      <div className="event-listing-filters">
        {filters.map(filter => (
          <SelectDropdown key={filter.value} {...propsSelectDropdown(filter)} />
        ))}
      </div>
      <div className="event-listing-filters__items-per-page-wrapper">
        {itemsPerPage}
      </div>
    </div>
  )
}

EventListingFilters.propTypes = {
  filters: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

EventListingFilters.defaultProps = {
  filters: [],
  loading: false
}

export default EventListingFilters
